enum HTTP_CUSTOM_CODE {
  CLIENT_ERROR = 455,
  SERVER_ERROR = 555,
}

const ERROR_MESSAGES = {
  '401error': 'Your session has expired. Please refresh the page and Sign in again.',
  '403error': `You don't have permission to access to DrillX. Please contact the DrillX Team at drillx@totalenergies.com, provide your IGG, name and email address.`,
  '400error': 'Bad request',
  '404error': 'Resource not found',
  default: 'An error occured',
};

export const getErrorMessage = (error?: {
  status?: number;
  response?: { body: { message: string } };
}) => {
  switch (error?.status) {
    case 401:
      return ERROR_MESSAGES['401error'];
    case 403:
      return ERROR_MESSAGES['403error'];
    case 400:
      return ERROR_MESSAGES['400error'];
    case 404:
      return ERROR_MESSAGES['404error'];
    case HTTP_CUSTOM_CODE.CLIENT_ERROR:
    case HTTP_CUSTOM_CODE.SERVER_ERROR:
      return error?.response?.body.message;
    default:
      return ERROR_MESSAGES['default'];
  }
};
